import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import AppContext from 'context/AppContext';
import RemoteConfigProvider from 'context/RemoteConfigContext';
import AuthProvider from 'context/AuthContext';
import AxiosProvider from 'components/utils/AxiosProvider';
import UserProvider from 'context/UserContext';
import ApplicationProvider from 'context/ApplicationContext';
import ThemeProvider from 'assets/styles/Theme';
import App from './App';

const AppWrapper = ({appConfig}) => {
    return (
        <React.StrictMode>
            <AppContext appConfig={appConfig}>
                <ThemeProvider>
                    <BrowserRouter>
                        <RemoteConfigProvider>
                            <AuthProvider>
                                <AxiosProvider>
                                    <UserProvider>
                                        <ApplicationProvider>
                                            <App />
                                        </ApplicationProvider>
                                    </UserProvider>
                                </AxiosProvider>
                            </AuthProvider>
                        </RemoteConfigProvider>
                    </BrowserRouter>
                </ThemeProvider>
            </AppContext>
        </React.StrictMode>
    );
};

export default AppWrapper;
